<!-- src/components/SectionInfo.vue -->
<template>
    <v-card outlined class="mb-4">
      <v-card-title class="subtitle-1 d-flex justify-space-between align-center">
        {{ title }}
        <v-btn small color="primary" @click="$emit('add')">
          <v-icon left>mdi-plus</v-icon>新增条目
        </v-btn>
      </v-card-title>
      <v-card-text>
        <template v-if="localItems.length === 0">
          <div class="text-center grey--text py-4">暫無{{ title }}信息</div>
        </template>
        <template v-else>
          <div v-for="(item, index) in localItems" 
               :key="index"
               class="mb-6 pa-4 lighten-5 rounded-lg">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="body-1">{{ title }} {{ index + 1 }}</span>
              <v-btn icon small @click="$emit('remove', index)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-text-field
              v-model="item.subTitle"
              :label="field1Label"
              outlined
              class="mb-2"
              @input="handleInput"
            ></v-text-field>
            <v-textarea
              v-model="item.description"
              :label="field2Label"
              rows="2"
              outlined
              @input="handleInput"
            ></v-textarea>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  export default {
    name: 'SectionInfo',
    props: {
      title: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      field1Label: {
        type: String,
        default: '標題'
      },
      field2Label: {
        type: String,
        default: '描述'
      }
    },
    data() {
      return {
        localItems: JSON.parse(JSON.stringify(this.items))
      }
    },
    watch: {
      items: {
        handler(newVal) {
          this.localItems = JSON.parse(JSON.stringify(newVal))
        },
        deep: true
      }
    },
    methods: {
      handleInput() {
        this.$emit('update', [...this.localItems])
      }
    }
  }
  </script>